export default (function () {
    const customCheckbox = {
        init() {
            $(document).on('change', 'input[type="checkbox"]', function () {
                $(this).closest('.custom_checkbox').toggleClass('custom_checkbox--active');
                const $checkboxInCheckout = $(this).closest('#opc-out-content');
                if ($checkboxInCheckout.length > 0 && $(this).is(':checked')) {
                    $checkboxInCheckout.find('.opc-form-group').removeClass('opc-has-error');
                }
            });
        },
    };
    $(document).ready(() => {
        customCheckbox.init();
    });
}());
